import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import firebase from 'firebase/app';
import 'firebase/auth';

import * as actions from '../../../store/actions/index';
import axios from '../../../utils/config-axios';
import {buildLogMessage,DEFAULT_ERROR_MESSAGE_1} from '../../../utils/error-helper';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import LinkButton from '../../../components/UI/Buttons/LinkButton';
import ActionButton from '../../../components/UI/Buttons/ActionButton';
import ButtonAndSpinner2 from '../../../components/UI/Buttons/ButtonAndSpinner2';
import SecondaryButton from "../../../components/UI/Buttons/SecondaryButton";


import classes from './LoginForm.module.scss';


/**
 * CHECKED-2021
 */
class LoginForm extends Component {

    state = {

        submitInProgress:false,
        submitInProgressType:null,

        username:"",
        password:"",

        passwordHidden:true,
    };


    componentDidMount(){

        this.setState({
            passwordHidden:true
        });

        //
        // User is already logged out since they are on the public home screen.
        // No reason to force a logout here.
        //
        this.props.clearSecurityContext();
        this.props.setSecurityContextLoginMessage(null,0);

    }



    submitLogin = () => {

        if(this.state.submitInProgress){
            return;
        }

        this.props.setSecurityContextLoginMessage(null,0);

        const data = {
            username:this.state.username,
            password: this.state.password
        };

        this.setState({
            submitInProgress:true,
            submitInProgressType:"local"
        });

        let responseData=null;


        axios({
            url: '/api/public/login/submit',
            method: 'POST',
            data: data
        }).then(result => {

            // console.log("LOGIN result",result);

            responseData = result;

            if(result.data.status!==1){

                throw new Error(result.data.message);
            }

            //
            // Existing and future Auth states are now persisted in the current
            // session only. Closing the window would clear any existing state even
            // if a user forgets to sign out.
            //
            // New sign-in will be persisted with session persistence.
            //
            // LOCAL - DEV ONLY
            //return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

            return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
        }).then(() => {

            //
            // Setup session.
            //
            return firebase.auth().signInWithCustomToken(responseData.data.token);

        }).catch(error => {

            // console.log("ERROR", error);

            this.setState({
                submitInProgress:false
            });

            //
            // Get login status from AMI response.
            // Otherwise, set to -1 : System Error
            //
            const login_status = (responseData && responseData.data && responseData.data.status) ? responseData.data.status : -1;

            let message;
            if(login_status===-210){
                message = (
                    <React.Fragment>
                        Please login using AbbVie SSO.
                        <br/>
                        If you have not already registered for access to this site, please do so before attempting to login using SSO.
                    </React.Fragment>);
            } else {
                message = error.message ? error.message : "An error occurred.";
            }

            this.props.setSecurityContextLoginMessage(message,login_status);

            this.signUserOutOnError();
        });
    };




    signUserOutOnError = () => {

        // console.log("USER LOGGED OUT - LoginForm");

        this.props.clearSecurityContext();

        // Sign out user...
        firebase.auth().signOut().then(() => {
            //
            // Sign-out successful.
            //
        }).catch((error) => {
            // An error happened.
            console.log("Failed to sign user out.", buildLogMessage(error) );
        });
    };



    toggleShowPassword = (e) => {
        e.stopPropagation();
        e.preventDefault();

        this.setState({ passwordHidden: !this.state.passwordHidden });
    };


    fieldChangedHandler = (event) => {

        this.setState( {
            [event.target.name] : event.target.value
        } );

        this.props.setSecurityContextLoginMessage(null,0);
    };


    onKeyDownHandler = (event) => {
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();

            this.submitLogin();
        }
    };


    submitOauthRedirect = () => {

        if(this.state.submitInProgress){
            return;
        }

        this.props.setSecurityContextLoginMessage(null,0);


        this.setState({
            submitInProgress:true,
            submitInProgressType:"oauth"
        });


        axios({
            url: '/api/public/oauth/authorize-form-redirect',
            method: 'GET'
        }).then(result => {

            // console.log("result",result);

            if(result.data.status!==1){

                throw new Error(result.data.message);
            }

            window.location = result.data.redirectUrl;

        }).catch(error => {

            // console.log("ERROR", error);

            this.setState({
                submitInProgress:false
            });

            this.props.setSecurityContextLoginMessage(DEFAULT_ERROR_MESSAGE_1,-1);

            this.signUserOutOnError();
        });
    };



    render() {

        let loginStatusMessage=null;
        if(this.props.login_status===-14){
            loginStatusMessage = (
                <div><LinkButton underline={true} to={"/request-password-change"}>Click to update password.</LinkButton></div>
            );
        } else if(this.props.login_status===-12){
            loginStatusMessage = (
                <div><LinkButton underline={true} to={"/technical-support"}>Request to unlock account.</LinkButton></div>
            );
        }

        return (

            <div className={classes.loginForm}>

                <h3 className={classes.title+" medium-brown mb-0"}>Welcome</h3>

                {/*<p className={"p-regular text-center mt-4"}>*/}
                {/*    Please enter your username*/}
                {/*    <br/>*/}
                {/*    (email used at registration) and password.*/}
                {/*</p>*/}

                <div className={"para-2 error-color "+classes.login_message}>
                    {this.props.login_message}
                    {loginStatusMessage}

                </div>

                <div className={"mt-3"}>
                    <form>

                        <div className={classes.formControl}>
                            <label htmlFor="username">Username</label>
                            <input name="username"
                                   type="text"
                                   maxLength={50}
                                   placeholder={"Enter email used at registration"}
                                   className={classes.inputText + " w-100"}
                                   value={this.state.username}
                                   onKeyDown={this.onKeyDownHandler}
                                   onChange={ (event)=>this.fieldChangedHandler(event,this)}/>

                        </div>

                        <div className={classes.formControl+" mt-4"}>
                            <label htmlFor="password">Password</label>
                            <input name="password"
                                   type={this.state.passwordHidden ? 'password' : 'text'}
                                   maxLength={50}
                                   placeholder={"Enter Password"}
                                   className={classes.inputText+" w-100"}
                                   value={this.state.password}
                                   onKeyDown={this.onKeyDownHandler}
                                   onChange={ (event)=>this.fieldChangedHandler(event,this)}/>

                            <ActionButton className={classes.showHideBtn}
                                          onClick={this.toggleShowPassword}><i className={(this.state.passwordHidden)? "fa fa-eye": "fa fa-eye-slash"}></i></ActionButton>

                        </div>

                    </form>

                    <ButtonAndSpinner2 className={classes.button+" mt-4 " + classes.loginButton}
                                      style={{"backgroundColor":"var(--neutral-grey-80)"}}
                                      onClick={this.submitLogin}
                                      submitInProgress={this.state.submitInProgress && this.state.submitInProgressType==="local"}
                                      label1={"Sign in"}
                                      label2={"Sign in"}>
                    </ButtonAndSpinner2>
                </div>

                <Row className={"p-regular mt-4 mb-4"}>
                    <Col >
                        <SecondaryButton className={classes.button} onClick={()=>this.props.history.push("/registration")}>Register for an Account</SecondaryButton>
                    </Col>
                </Row>

                <div className={"p-small mt-4 mb-4 d-flex justify-content-between"}>
                    <div xs={12} sm={6} className={"mb-3"}>
                        {/*<LinkButton underline={true} onClick={this.submitOauthRedirect}>Login via SSO<br/> (Internal AbbVie Users Only)</LinkButton>*/}
                        <button className={"link-styled-button"} onClick={this.submitOauthRedirect}>Login via SSO<br/> (Internal AbbVie Users Only)</button>
                    </div>
                    <div xs={12} sm={6} className={"flex-column"}>
                        <p>
                            <LinkButton underline={true} to={"/technical-support"}>Trouble logging in?</LinkButton>
                            <br/>
                            <LinkButton underline={true} to={"/request-password-change"}>Forgot password?</LinkButton>
                            <br/>
                            <LinkButton underline={true} to={"/technical-support"}>Technical Support</LinkButton>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}





const mapStateToProps = (state) => {
    return {
        login_message: state.security.login_message,
        login_status: state.security.login_status
    }
};



const mapDispatchToProps = (dispatch) => {
    return {
        clearSecurityContext: () => {
            dispatch( actions.clearSecurityContext() );
        },
        setSecurityContextLoginMessage: (login_message, login_status) => {
            dispatch( actions.setSecurityContextLoginMessage(login_message, login_status) );
        }
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));
